/* globals global window */
/* eslint-disable import/prefer-default-export */
const GLOBALS = typeof window === 'undefined' ? global : window
export const getPathWithDomain = path => GLOBALS.GIGPLANET_SETTINGS.SERVER_HOST + path
